import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { css } from "styled-components";

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding: 0px;
        background: #f0f4f3;
        border-radius: 4px;
        margin: 2rem 1rem !important;
    `,
};
